import API from '@/api/api.js'
import Moment from 'moment';
import Qs from 'qs'

export default class MyAPIList {
  constructor() {
    let api = new API();
    this.api = api;
  }

  getCustomer(params, success, error) {
    this.api.get('/customer/profile', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getUser(param, success, error) {
    this.api.get('/user/detail', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getAgent(param, success, error) {
    this.api.get('/agent/profile', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  changePassword(param, success, error) {
    this.api.post('/user/changePassword', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  editPreference(param, success, error) {
    this.api.post('/preference/edit', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/My/apiList.js